var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container order-list" },
    [
      _c("breadcrumb", { attrs: { breadcrumbConfig: _vm.breadcrumbConfig } }),
      _vm._m(0),
      _vm.stepsActive == 1
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("h3", [_vm._v("数据筛选")]),
              _c("form-filed", {
                ref: "formAttr",
                staticClass: "search-form",
                attrs: {
                  formconfig: _vm.searchFormConfig.formconfig,
                  formData: _vm.searchFormConfig.formData,
                },
                on: { formDataval: _vm.dialogClick },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.stepsActive == 1
        ? _c(
            "div",
            { staticClass: "box" },
            [
              _c("div", { staticClass: "headerTitle" }, [_vm._v("商品列表")]),
              _c(
                "el-tabs",
                {
                  on: { "tab-click": _vm.getClickTabList },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "选择商品", name: "goods" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", [
                          _vm._v(
                            "选择商品(" +
                              _vm._s(
                                _vm.titleNum.totalCount
                                  ? _vm.titleNum.totalCount
                                  : 0
                              ) +
                              ")"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    { attrs: { label: "选择赠品", name: "second" } },
                    [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", [
                          _vm._v(
                            "选择赠品(" +
                              _vm._s(
                                _vm.titleNum.giftCount
                                  ? _vm.titleNum.giftCount
                                  : 0
                              ) +
                              ")"
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c("lb-table", {
                attrs: {
                  column: _vm.columns,
                  data: _vm.page.list,
                  pagination: "",
                  "max-height": "400",
                  total: _vm.page.totalNum,
                  layout: "total, sizes, prev, pager, next, jumper",
                  "page-sizes": [5, 10, 20, 30, 50],
                  "current-page": _vm.page.currentPage,
                  "page-size": _vm.page.pageSize,
                  "default-sort": { prop: "date", order: "descending" },
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.page, "currentPage", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "p-current-change": _vm.handleCurrentChange,
                  "sort-change": _vm.handleSort,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.stepsActive == 2
        ? _c("div", { staticClass: "content" }, [
            _c("h3", [_vm._v("基础信息")]),
            _c("div", { staticClass: "details" }, [
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [
                  _vm._v("客户姓名"),
                ]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.clientMessage.userName
                        ? _vm.clientMessage.userName
                        : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [
                  _vm._v("手机号码1"),
                ]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.clientMessage.phone1 ? _vm.clientMessage.phone1 : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [
                  _vm._v(" 手机号码2"),
                ]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.clientMessage.phone2 ? _vm.clientMessage.phone2 : "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [_vm._v("性别")]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(_vm._s(_vm.clientMessage.genderCN)),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [_vm._v("年龄")]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(
                    _vm._s(_vm.clientMessage.age ? _vm.clientMessage.age : "-")
                  ),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [
                  _vm._v("购买次数"),
                ]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(_vm._s(_vm.buyNumber)),
                ]),
              ]),
              _c("div", { staticClass: "details_item" }, [
                _c("div", { staticClass: "details_title" }, [
                  _vm._v("创建时间"),
                ]),
                _c("div", { staticClass: "details_value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.clientMessage.createdTimeNew
                        ? _vm.clientMessage.createdTimeNew
                        : "-"
                    )
                  ),
                ]),
              ]),
              _vm._m(1),
              _vm._m(2),
              _vm._m(3),
            ]),
          ])
        : _vm._e(),
      _vm.stepsActive == 2
        ? _c(
            "div",
            { staticClass: "content" },
            [
              _c("div", { staticClass: "addressBox" }, [
                _c("div", { staticClass: "headerTitle shopTitle" }, [
                  _vm._v("选择收货地址"),
                ]),
                _vm.siteDataList.length == 0
                  ? _c(
                      "div",
                      { staticClass: "addressHeader" },
                      [
                        _c("i", {
                          staticClass: "el-icon-circle-plus-outline",
                          staticStyle: { color: "#4168e7" },
                        }),
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#4168e7" },
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.addLocation()
                              },
                            },
                          },
                          [_vm._v("新增收货地址")]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _c(
                "el-table",
                {
                  staticClass: "site-data-list",
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.siteDataList,
                    stripe: "",
                    "header-cell-style": {
                      background: "#faf7fa",
                      color: "#333333",
                    },
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "收货人", prop: "userName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "手机号码", prop: "phone" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "地区", prop: "userName" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("p", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      props.row.provinceCode
                                        ? props.row.provinceCode +
                                            props.row.cityCode +
                                            props.row.regionCode
                                        : "-"
                                    ) +
                                    " "
                                ),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      144567753
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "详细地址", prop: "detailedAddress" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "默认地址" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("el-switch", {
                                attrs: {
                                  "active-value": 1,
                                  "inactive-value": 0,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.defaultSite(props.row.id)
                                  },
                                },
                                model: {
                                  value: props.row.isDefault,
                                  callback: function ($$v) {
                                    _vm.$set(props.row, "isDefault", $$v)
                                  },
                                  expression: "props.row.isDefault",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      234956708
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "操作" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.amendAddress("addressEdit")
                                    },
                                  },
                                },
                                [_vm._v("更改 ")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1047409353
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "orderBox" }, [
        _c(
          "div",
          { staticClass: "order" },
          [
            _c("p", { staticClass: "headerTitle shopTitle" }, [
              _vm._v("已选商品"),
            ]),
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: { data: _vm.orderDetailList },
              },
              [
                _c("el-table-column", {
                  attrs: {
                    "min-width": "200px",
                    label: "商品信息",
                    "header-align": "left",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("div", { staticClass: "goodsBox" }, [
                            _c(
                              "div",
                              { staticClass: "imgBox" },
                              [
                                _c("el-image", {
                                  attrs: {
                                    src: scope.row.mainImage,
                                    "preview-src-list": scope.row.mainImageArr,
                                    fit: "cover",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c("div", { staticClass: "goodsBox_title" }, [
                              _c("h3", [
                                _c("span", [_vm._v(_vm._s(scope.row.name))]),
                              ]),
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(scope.row.specTitle),
                                },
                              }),
                              _c("p", { staticClass: "goods-id" }, [
                                _vm._v(
                                  "商品编号：" + _vm._s(scope.row.goodsNo)
                                ),
                              ]),
                              scope.row.goodsType == 3 ||
                              scope.row.goodsType == "赠品"
                                ? _c("span", { staticClass: "gift" }, [
                                    _vm._v("赠品"),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "单价/数量",
                    "header-align": "left",
                    prop: "quantity",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "table-price",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _c(
                                "p",
                                { staticClass: "retail-price" },
                                [
                                  _c("label", [_vm._v("零售价：")]),
                                  _c("el-input", {
                                    attrs: { size: "mini" },
                                    model: {
                                      value: scope.row.retailPrice,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "retailPrice",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "scope.row.retailPrice",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("p", [
                                _vm._v(
                                  "市场价：￥" +
                                    _vm._s(scope.row.marketPrice.toFixed(2))
                                ),
                              ]),
                              _vm.stepsActive == 2
                                ? _c(
                                    "p",
                                    { staticStyle: { color: "#999999" } },
                                    [_vm._v("x" + _vm._s(scope.row.quantity))]
                                  )
                                : _vm._e(),
                              _vm.stepsActive == 1
                                ? _c(
                                    "p",
                                    [
                                      _c("el-input-number", {
                                        attrs: {
                                          size: "mini",
                                          min: 1,
                                          label: "描述文字",
                                        },
                                        model: {
                                          value: scope.row.quantity,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "quantity", $$v)
                                          },
                                          expression: "scope.row.quantity",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "total",
                    label: "小计",
                    "header-align": "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("p", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(
                              "实付￥" +
                                _vm._s(
                                  parseFloat(
                                    scope.row.totalRetailPrice
                                  ).toFixed(2)
                                )
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "right" } }, [
                            _vm._v(
                              "￥" +
                                _vm._s(
                                  parseFloat(
                                    scope.row.totalMarketPrice
                                  ).toFixed(2)
                                )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _vm.stepsActive == 1
                  ? _c("el-table-column", {
                      attrs: {
                        "min-width": "120px",
                        label: "操作",
                        "header-align": "right",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "text-align": "right" } },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.delectSelect(
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("移除商品")]
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4144499073
                      ),
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "orderNotes" }, [
          _vm._m(4),
          _c(
            "div",
            { staticClass: "notes" },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "200",
                  type: "textarea",
                  "show-word-limit": "",
                  placeholder: "备注",
                },
                model: {
                  value: _vm.textarea,
                  callback: function ($$v) {
                    _vm.textarea = $$v
                  },
                  expression: "textarea",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "statistics" }, [
          _c("p", { staticClass: "fourteen" }, [
            _c("span", [
              _vm._v(
                "总计：共 " +
                  _vm._s(_vm.totalNumber ? _vm.totalNumber : "0") +
                  " 件 "
              ),
            ]),
          ]),
          _c("p", { staticClass: "fourteen" }, [
            _c("span", [
              _vm._v(
                "商品总价：￥" + _vm._s(_vm.totalPrice ? _vm.totalPrice : "0")
              ),
            ]),
          ]),
          _c("p", { staticClass: "fourteen" }, [
            _c("span", [
              _vm._v("运费￥" + _vm._s(_vm.giftPrice ? _vm.giftPrice : "0")),
            ]),
          ]),
          _c("p", { staticStyle: { "margin-right": "20px" } }, [
            _c("span", { staticClass: "blue" }, [
              _vm._v("应付:￥"),
              _vm.stepsActive == 2
                ? _c("span", [
                    _vm._v(_vm._s(_vm.dealWithNew ? _vm.dealWithNew : "0")),
                  ])
                : _vm._e(),
            ]),
            _vm.stepsActive == 1
              ? _c(
                  "span",
                  [
                    _c("el-input-number", {
                      staticStyle: { width: "80px" },
                      attrs: {
                        controls: false,
                        precision: 2,
                        size: "mini",
                        placeholder: "",
                      },
                      model: {
                        value: _vm.dealWithNew,
                        callback: function ($$v) {
                          _vm.dealWithNew = $$v
                        },
                        expression: "dealWithNew",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _c("p", { staticStyle: { "margin-right": "20px" } }, [
            _vm.stepsActive == 1
              ? _c("span", [
                  _c("span", { staticClass: "blue" }, [_vm._v("已收:￥")]),
                  _c(
                    "span",
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "80px" },
                        attrs: {
                          controls: false,
                          precision: 2,
                          size: "mini",
                          placeholder: "",
                        },
                        on: { blur: _vm.handlerReceivedMoney },
                        model: {
                          value: _vm.receivedMoney,
                          callback: function ($$v) {
                            _vm.receivedMoney =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "receivedMoney",
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.stepsActive == 2
              ? _c("span", [
                  _c("span", { staticClass: "blue" }, [
                    _vm._v("(已收:￥"),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.receivedMoney ? _vm.receivedMoney : "0")
                      ),
                    ]),
                    _vm._v(")"),
                  ]),
                ])
              : _vm._e(),
          ]),
        ]),
        _vm.stepsActive == 2 && _vm.auditStatus != -1
          ? _c("div", { staticClass: "auditRadio" }, [
              _c("span", [_vm._v("是否审核:")]),
              _c(
                "div",
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.radioForm.resource,
                        callback: function ($$v) {
                          _vm.$set(_vm.radioForm, "resource", $$v)
                        },
                        expression: "radioForm.resource",
                      },
                    },
                    [
                      _c(
                        "el-radio",
                        { attrs: { disabled: _vm.whether, label: "1" } },
                        [_vm._v("是")]
                      ),
                      _c(
                        "el-radio",
                        { attrs: { disabled: _vm.whether, label: "0" } },
                        [_vm._v("否")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
      _c(
        "div",
        { staticClass: "present" },
        [
          _vm.stepsActive == 2
            ? _c(
                "el-button",
                { staticClass: "cancel-order", on: { click: _vm.cancelOrder } },
                [_vm._v("取消订单")]
              )
            : _vm._e(),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.activeSubmit } },
            [_vm._v("生成订单")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            "append-to-body": "",
            width: _vm.dialog.width,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type == "moreSpecification"
            ? [
                _vm._l(_vm.specList, function (item, index) {
                  return _c("div", { key: index, staticClass: "skuBox" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v(_vm._s(item.name)),
                    ]),
                    _c(
                      "div",
                      { staticClass: "spec" },
                      _vm._l(item.specItemList, function (its, ins) {
                        return _c(
                          "div",
                          { key: its.content + ins, staticClass: "spec-item" },
                          [
                            _c(
                              "span",
                              {
                                class: [
                                  _vm.selectSpec[item.name] == its.content
                                    ? "active"
                                    : "",
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.changeSpec(
                                      item.name,
                                      its.content
                                    )
                                  },
                                },
                              },
                              [_vm._v(_vm._s(its.content))]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                }),
                _c("div", { staticClass: "specificationBox" }, [
                  _c("p", { staticClass: "specificationBox_title" }, [
                    _c("span", { staticClass: "specificationBox_title_item" }, [
                      _vm._v("已选规格："),
                    ]),
                    _c(
                      "span",
                      { staticClass: "specificationBox_title_right" },
                      [
                        _vm.matchingStr == ""
                          ? _c("b", [_vm._v("未选择")])
                          : _c("b", {
                              domProps: { innerHTML: _vm._s(_vm.matchingStr) },
                            }),
                      ]
                    ),
                  ]),
                  _c("div", { staticClass: "specificationBox_border" }, [
                    _c("div", { staticClass: "specificationBox_border_item" }, [
                      _c("span", { staticClass: "item" }, [_vm._v("市场价")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item" }, [_vm._v("零售价")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item" }, [_vm._v("销量")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "item" }, [_vm._v("库存")]),
                    ]),
                    _c(
                      "div",
                      { staticClass: "specificationBox_border_money" },
                      [
                        _c("span", { staticClass: "item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.matching.marketPrice
                                ? "￥" + _vm.matching.marketPrice
                                : "-"
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.matching.retailPrice
                                ? "￥" + _vm.matching.retailPrice
                                : "-"
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.matching.soldNum || _vm.matching.soldNum === 0
                                ? _vm.matching.soldNum
                                : "-"
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "item" }, [
                          _vm._v(
                            _vm._s(
                              _vm.matching.stock ? _vm.matching.stock : "-"
                            )
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "dialogBtnright",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_quxiao",
                        on: { click: _vm.handledeleteClose },
                      },
                      [_vm._v("取 消")]
                    ),
                    _c(
                      "el-button",
                      {
                        staticClass: "setPay_payment_btn_queren",
                        attrs: { type: "primary" },
                        on: { click: _vm.addSelectList },
                      },
                      [_vm._v("确 定")]
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addressAmend"
            ? [
                _c(
                  "span",
                  { staticClass: "addressHeader" },
                  [
                    _c("i", {
                      staticClass: "el-icon-circle-plus-outline",
                      staticStyle: { color: "#4168e7" },
                    }),
                    _c(
                      "el-button",
                      {
                        staticStyle: { color: "#4168e7" },
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.addAddress("Address")
                          },
                        },
                      },
                      [_vm._v("新增收货地址")]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-table",
                  {
                    attrs: {
                      data: _vm.addressDataList,
                      "header-cell-style": {
                        background: "#F8F8F9",
                        color: "#333333",
                      },
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "收货人", prop: "userName" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "手机号码", prop: "phone" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "地区", prop: "userName" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("p", [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.provinceCode +
                                          props.row.cityCode +
                                          props.row.regionCode
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1709687410
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "详细地址", prop: "detailedAddress" },
                    }),
                    _c("el-table-column", {
                      attrs: { label: "默认地址" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.defaultSite(props.row.id)
                                    },
                                  },
                                  model: {
                                    value: props.row.isDefault,
                                    callback: function ($$v) {
                                      _vm.$set(props.row, "isDefault", $$v)
                                    },
                                    expression: "props.row.isDefault",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        234956708
                      ),
                    }),
                    _c("el-table-column", {
                      attrs: { label: "操作" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.employ(props.row)
                                      },
                                    },
                                  },
                                  [_vm._v("使用 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogEdit(
                                          "editAddress",
                                          props.row
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("编辑 ")]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { color: "red" },
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.dialogDelete(props.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除 ")]
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1854051084
                      ),
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "addAddress" || _vm.dialog.type == "addLocation"
            ? [
                _c(
                  "el-form",
                  {
                    ref: "form",
                    attrs: {
                      model: _vm.form,
                      rules: _vm.rules,
                      "label-width": "80px",
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "97%" },
                        attrs: {
                          label: "收货人姓名",
                          "label-width": "100px",
                          prop: "userName",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入收货人姓名" },
                          model: {
                            value: _vm.form.userName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "userName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.userName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "联系电话",
                          "label-width": "100px",
                          prop: "phone",
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "96%" },
                          attrs: {
                            placeholder: "请输入联系电话",
                            oninput: "value=value.replace(/[^0-9.]/g,'')",
                            maxLength: 11,
                          },
                          model: {
                            value: _vm.form.phone,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "phone",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.phone",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "收货地址",
                          "label-width": "100px",
                          prop: "addressValue",
                        },
                      },
                      [
                        _c("el-cascader", {
                          staticStyle: { width: "96%" },
                          attrs: {
                            placeholder: "请选择收货地址",
                            options: _vm.addressOptions,
                            clearable: "",
                            filterable: "",
                          },
                          on: { change: _vm.onChangeAddress },
                          model: {
                            value: _vm.form.addressValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "addressValue", $$v)
                            },
                            expression: "form.addressValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "详细地址",
                          "label-width": "100px",
                          prop: "detailedAddress",
                        },
                      },
                      [
                        _c("el-input", {
                          staticStyle: { width: "96%" },
                          attrs: { placeholder: "请输入详细地址" },
                          model: {
                            value: _vm.form.detailedAddress,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.form,
                                "detailedAddress",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "form.detailedAddress",
                          },
                        }),
                        _c(
                          "el-checkbox",
                          {
                            attrs: { "false-label": 0, "true-label": 1 },
                            model: {
                              value: _vm.form.isDefault,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "isDefault", $$v)
                              },
                              expression: "form.isDefault",
                            },
                          },
                          [_vm._v("设为默认 ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "dialogBtn" },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "setPay_payment_btn_quxiao",
                            on: {
                              click: function ($event) {
                                _vm.dialog.visible = false
                              },
                            },
                          },
                          [_vm._v("取 消")]
                        ),
                        _c(
                          "el-button",
                          {
                            staticClass: "setPay_payment_btn_queren",
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.dialogSubmit("form")
                              },
                            },
                          },
                          [_vm._v("确 定 ")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm.dialog.type == "selectPay"
            ? [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectPayment },
                    model: {
                      value: _vm.setPay.payment,
                      callback: function ($$v) {
                        _vm.$set(_vm.setPay, "payment", $$v)
                      },
                      expression: "setPay.payment",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v("在线支付"),
                    ]),
                  ],
                  1
                ),
                _c("div", { staticClass: "setPayDialogBtn" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          on: { change: _vm.selectPayDefault },
                          model: {
                            value: _vm.setPay.payDefault,
                            callback: function ($$v) {
                              _vm.$set(_vm.setPay, "payDefault", $$v)
                            },
                            expression: "setPay.payDefault",
                          },
                        },
                        [
                          _c(
                            "el-checkbox",
                            { attrs: { label: "1", name: "type" } },
                            [_vm._v("设为默认")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.confirmSelectPay },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialog.type == "selectPayNew"
            ? [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.selectPayment },
                    model: {
                      value: _vm.selectPay,
                      callback: function ($$v) {
                        _vm.selectPay = $$v
                      },
                      expression: "selectPay",
                    },
                  },
                  _vm._l(
                    _vm.dictionaries.order_pay_type,
                    function (item, index) {
                      return _c(
                        "el-radio",
                        {
                          key: index,
                          staticClass: "setPay_payment",
                          attrs: { label: item.dictId },
                        },
                        [_vm._v(_vm._s(item.dictName))]
                      )
                    }
                  ),
                  1
                ),
                _c("div", { staticClass: "setPayDialogBtn" }, [
                  _c("div"),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.handlerSelectPay },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
          _vm.dialog.type == "payMoney"
            ? [
                _c("div", { staticClass: "payMoney" }, [
                  _c("div", [
                    _c("p", { staticClass: "payMoney_should" }, [
                      _vm._v(
                        "应付:￥" + _vm._s(_vm.dealWith ? _vm.dealWith : "0")
                      ),
                    ]),
                    _c("p", { staticClass: "payMoney_already" }, [
                      _vm._v(
                        "已收:￥" +
                          _vm._s(_vm.receivedMoney ? _vm.receivedMoney : "0")
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "payMoney_box" },
                    [
                      _c("span", { staticClass: "payMoney_money" }, [
                        _vm._v("支付金额"),
                      ]),
                      _c("span", { staticClass: "payMoney_mo" }, [
                        _vm._v("￥"),
                      ]),
                      _c("el-input-number", {
                        staticStyle: { width: "110px" },
                        attrs: {
                          controls: false,
                          mix: 0,
                          type: "number",
                          precision: 2,
                        },
                        model: {
                          value: _vm.paymentAmount,
                          callback: function ($$v) {
                            _vm.paymentAmount = $$v
                          },
                          expression: "paymentAmount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "payMoney_text" }, [
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "总计: 共" +
                          _vm._s(_vm.totalNumber ? _vm.totalNumber : "0") +
                          "件"
                      ),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "商品总价: ￥" +
                          _vm._s(_vm.totalPrice ? _vm.totalPrice : "0")
                      ),
                    ]),
                    _c("span", { staticClass: "payMoney_text_item" }, [
                      _vm._v(
                        "运费: ￥" + _vm._s(_vm.giftPrice ? _vm.giftPrice : "0")
                      ),
                    ]),
                  ]),
                ]),
                _c("div", { staticClass: "dialogBtnright" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_quxiao",
                          on: {
                            click: function ($event) {
                              _vm.dialog.visible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                      _c(
                        "el-button",
                        {
                          staticClass: "setPay_payment_btn_queren",
                          attrs: { type: "primary" },
                          on: { click: _vm.onlinePayment },
                        },
                        [_vm._v("确 定")]
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("修改订单")]),
      _c("div", { staticClass: "headerbox_right" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "details_item" }, [
      _c("div", { staticClass: "details_title" }),
      _c("div", { staticClass: "details_value" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "details_item" }, [
      _c("div", { staticClass: "details_title" }),
      _c("div", { staticClass: "details_value" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "details_item" }, [
      _c("div", { staticClass: "details_title" }),
      _c("div", { staticClass: "details_value" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerOrder" }, [
      _c("div", { staticClass: "orderRemak" }, [_vm._v("订单备注")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }